// AuthContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import Loading from '../components/Loading';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true); 

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setIsLoggedIn(true);
    }
    setIsLoading(false); 
  }, []);

  const login = () => setIsLoggedIn(true);
  const logout = () => setIsLoggedIn(false);

  return (
    <AuthContext.Provider value={{ isLoggedIn, login, logout, isLoading }}>
      {isLoading ? <Loading></Loading> : children} 
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
